export const SEND_BILL_METHOD_OPTIONS = [
  {
    text: 'Không gửi thông tin',
    value: null,
  },
  {
    text: 'Email',
    value: 'email',
  },
  {
    text: 'SMS',
    value: 'sms',
  },
];

export const MISSING_MANAGER_ASSISTANT_WARNING_MESSAGE =
  'Vui lòng chọn QLCH/TLCH và cấu hình ca làm việc cho QLCH/TLCH';

// Chỉ cảnh báo khi trống cả QLCH và TLCH
export const isMissingManagerAndAssistant = (employeeInfo) =>
  !employeeInfo || (!employeeInfo.managerId && !employeeInfo.assistantId);
